import React from 'react';
import Button from "react-bootstrap/Button";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Carousel from 'react-bootstrap/Carousel';
import Moment from "moment/moment";
import '../Curriculum.css';
import '../SideBar.css';
import {Col, Container, Row} from "react-bootstrap";

class Curriculum extends React.Component {
    state = {
        isLoading: true,
        users: [],
        error: null,
        post:{},
        careers: [],
        careerbyid: [],
        showmod : false,
        mediasbyid : [],
        myapp: 'https://api.nvdxavier.com/',
        educations : [],
        randomkey : Math.floor(Math.random() * 1001)

    };

    getEducations(){
        axios.get(process.env.REACT_APP_API_URLSF+`/api/education`)
            .then((response) =>{
                this.setState({educations: response.data});
            })
            .catch(err => console.error(err));
    }
    getActualCv() {
        fetch(process.env.REACT_APP_API_URLSF+`/api/curriculum/10`)
            .then((response) =>{
                return response.json()
            })
            .then((result) => {
                this.setState({post: result});
                this.setState({careers: result.career});
            })
            .catch(err => console.error(err));
    }
    showCareer(id){
        this.setState({showmod : true })
        axios.get(process.env.REACT_APP_API_URLSF+`/api/career/`+id)
            .then((result) => {
                    this.setState({careerbyid: result.data });
                    this.showMedia(id)
                })
                .catch(err => console.error(err));
    }
    showMedia(id){
        axios.get(process.env.REACT_APP_API_URLSF+`/api/media/`+id)
            .then((result) => {
                this.setState({mediasbyid: result.data });
            })
            .catch(err => console.error(err));
    }

    gotoschoolurl = (schoolurl) => {
        window.open(schoolurl, '_blank');
    };

    formatRoot(root){
        return root.substring(root.indexOf("/public"));
    }
    componentDidMount() {
        this.getActualCv();
        this.getEducations();
    }
    handleClose() {
        this.setState({showmod : false })
    };
    render() {
        const {
            error,
            post,
            careers
        } = this.state;
        const { careerbyid } = this.state;
         const { mediasbyid } = this.state;
         const { educations } = this.state;

        return (
            <React.Fragment>
            <section id="signup" className="signup-section">
                <Container key={post.id} fluid={true}>
                    <Row>
                        <Col className="col-lg-2"></Col>
                        <Col className="col-lg-3">
                            <div className="h-25 imgcontainer">
                                <img className="mylogo align-content-center" src="https://nvdxavier.com/MONLOGO2023.png" alt="mon logo"/>
                            </div>
                            <h5>Technos</h5>
                            <br/>
                            <p>PHP, Symfony, Joomla
                            MySQL, Postgresql, Oracle
                            Javascript, React, Jquery
                            Bootstrap, Twig, Html, Css</p>
                            <br/>
                            <h5>Langues</h5>
                            Français, anglais
                            <br/>
                            <br/>
                            <div className="mb-4" key={this.state.randomkey}>
                                <div>
                                    {educations.map( (education, key) => (
                                            <Button className="effect1 text-capitalize text-start no-bg-color" onClick={() => this.gotoschoolurl(education.link)}>
                                                <div className="align-content-center">
                                                    <strong>{education.degree}</strong>
                                                    <br/>
                                                    <cite key={key} title="Source Title">{education.school}</cite> - {Moment(education.dateend).format('MM/YYYY')}
                                                </div>
                                                <div className="align-content-center">
                                                </div>
                                            </Button>
                                        )
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col className="col-lg-5 text-center  align-content-lg-start border-separator">
                            <div className="mb-4">
                                <h2 className="nvdxaviercolor">{post.firstname} {post.lastname}</h2>
                                <h5>{post.title}</h5>
                                <br/>
                                <div>
                                    Nationalité: {post.nationality} <br/>
                                </div>
                                {post.email}
                            </div>
                            <div className="">
                                {post.description}
                            </div>
                            <hr/>

                         <span className="text-center mb-4">
                                <h3>Experiences</h3>
                            </span>
                            {careers.map(career => (
                                <Button className="dropdown-item effect1 mb-5 container" onClick={() => this.showCareer(career.id)}>
                                    <div id={career.id} className="align-content-lg-start text-center mb-2">
                                        <h5>{career.society}</h5>
                                        <i className="mb-3">Du {Moment(career.datestart).format("DD/MM/YYYY")} au {Moment(career.dateend).format("DD/MM/YYYY")}</i>
                                        <br/>
                                        <span>{career.jobtitle}</span>
                                    </div>
                                </Button>
                            ))}
                        </Col>
                        <Col className="col-lg-2"></Col>
                    </Row>
                </Container>

                {error ? <p> { error.message } < /p> : null}  {}
                <Modal show={this.state.showmod} onHide={() => this.handleClose()}>
                    <Modal.Header closeButton onClick={() => this.handleClose()}  className="modalopacity">
                        <Modal.Title>{careerbyid.jobtitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Carousel>
                            {mediasbyid.map((mediabyid, key) => (
                                <Carousel.Item interval={1500}>
                                 <img key={key}
                                     className="d-block w-100 h-75"
                                     src={`${this.state.myapp}${this.formatRoot(mediabyid.folder)}/${mediabyid.name}`}
                                     alt={`${mediabyid.id}`}
                                 />
                                    <br/>
                                 <Carousel.Caption>
                                     <h3>{careerbyid.society}</h3>
                                 </Carousel.Caption>
                             </Carousel.Item>
                            ))}
                        </Carousel>
                        <div id={careerbyid.id}>
                            <strong>Société:</strong>
                            <h5>{careerbyid.society} </h5>
                            Du {Moment(careerbyid.datestart).format("DD/MM/YYYY")} au {Moment(careerbyid.dateend).format("DD/MM/YYYY")}
                            <br/>
                            <hr/>
                            <span className="text-left"> <strong>Description du poste:</strong> </span>
                            <p dangerouslySetInnerHTML={ {__html: careerbyid.taskdescription} }/>
                            <br/>
                            <span> <strong>Site web:</strong>
                                <a href={careerbyid.link} className="list-group-item list-group-item-action">{careerbyid.link}</a>
                            </span>
                        </div>
                    </Modal.Body>
                </Modal>
            </section>
            < /React.Fragment> );

    }
}
export default Curriculum;